import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { ArrowsUpDownIcon } from "@heroicons/react/24/outline";
import { useTranslations } from "use-intl";
import { ThreadSort } from "@/gql/graphql";

const OPTIONS = [
  { value: ThreadSort.LatestMessage, label: "latestMessage" },
  { value: ThreadSort.UnreadFirst, label: "unreadFirst" },
] as const;

export function ThreadSortMenu({
  sort,
  onSortChange,
}: {
  sort: ThreadSort;
  onSortChange: (sort: ThreadSort) => void;
}) {
  const t = useTranslations("thread.sort");

  return (
    <DropdownMenu>
      <Tooltip>
        <TooltipTrigger asChild>
          <DropdownMenuTrigger asChild>
            <button
              type="button"
              aria-label={t("title")}
              className="rounded-md p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
            >
              <ArrowsUpDownIcon className="h-5 w-5" />
            </button>
          </DropdownMenuTrigger>
        </TooltipTrigger>
        <TooltipContent>{t("title")}</TooltipContent>
      </Tooltip>
      <DropdownMenuContent align="end">
        <DropdownMenuRadioGroup
          value={sort}
          onValueChange={(value) => onSortChange(value as ThreadSort)}
        >
          {OPTIONS.map((option) => (
            <DropdownMenuRadioItem key={option.value} value={option.value}>
              {t(option.label)}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
